import Popup from "./Popup";
import Trigger from "./Trigger";
Popup.displayName = "Popup";
Popup.Trigger = Trigger;
export default Popup;
//# sourceMappingURL=index.js.map